module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("1Pxwq"))).then(() => parcelRequire('37nVf'));